


























































































































































































import { Component, Prop } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { FormulasService } from '@/modules/formulas/formulas-service';
import { required, integer, minValue } from 'vuelidate/lib/validators';
import { TanksApi, Tank, OrgsApi, Entities } from '@/api';
import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import ChartAdmin from '@/components/charts/chart-admin.vue';
import Toast from '@/components/display/toast.vue';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import { FuelTankVolumeCalculator } from '@/typings/fuel-volume-calculator';
import { AxiosError } from 'axios';
import { mixins } from 'vue-class-component';
import { Validations } from 'vuelidate-property-decorators';
import { Constants } from '@/common/Constants';
import CustomFormulaConfiguration from '@/components/form pickers/CustomFormulaConfiguration.vue';
import { FormulaInput } from '@/modules/formulas/models/formula-input';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: {
		SaveCancelButtons,
		routerLinkButton,
		TransceiverSuggest,
		SensorSuggest,
		secondaryNav,
		ChartAdmin,
		Toast,
		CustomFormulaConfiguration,
	},

	mixins: [validationMixin],
})
export default class ProvisionTankModal extends mixins(validationMixin) {
	@Prop(Object)
	public tank!: Tank;
	@Prop(String)
	public modalType!: String;

	public calculation = {};
	public parameters: Record<string, any> = {};
	public calculatingTank = false;
	public fuelTypes = [];
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public formulaInputs: FormulaInput[] = [];

	public get formulaOptions() {
		return this.formulasService.formulaOptions;
	}

	private formulasService: FormulasService = new FormulasService(Entities.Tanks);

	public distributors = [];
	@Validations()
	public validations() {
		return {
			tank: {
				formulaId: { required },
				fuelType: { required },
				totalHeight: { integer, minValue: minValue(0) },
				nominalVolume: { required, integer, minValue: minValue(0) },
				fluctuation: { required, integer },
				distributorId: { integer },
				outletHeight: { integer, minValue: minValue(0) },
				safeFillVolume: { integer, minValue: minValue(0) }, // between: between(0, 1000)
			},
		};
	}
	public cancel() {
		this.$bvModal.hide(`${this.modalType}Modal${this.tank.id}`);
		this.$emit('loadTank');
	}

	public onFormulaChanged(formulaId: number): void {
		this.tank.formulaId = formulaId;
		this.formulaInputs = this.formulasService.getFormulaInputs(this.tank.formulaId) ?? [];
		this.calculateTankVolume();
	}

	public onFormulaParametersChanged(inputs: FormulaInput[]): void {
		this.formulaInputs = inputs;
		this.calculateTankVolume();
	}

	// calculate levno Amount from fuel volume calculator
	public async calculateTankVolume() {
		this.calculatingTank = true;
		this.parameters = {};
		this.formulaInputs.forEach(i => (this.parameters[i.name] = i.value));
		try {
			if (this.tank.formulaId) {
				const formula = this.formulasService.formulas?.find(f => f.id === this.tank.formulaId);
				if (!formula) {
					this.calculatingTank = false;
					return;
				}
				this.calculation = await FuelTankVolumeCalculator.calculate(
					9999999, // mod
					formula.formula ?? '',
					formula.name,
					this.$route.params,
					this.parameters,
					{ width: 0, height: 0, length: 0, offset: '0' }, // mod
					9999999,
					9999999,
					9999999,
					9999999,
				);
			}
		} catch (e) {
			console.log(e);
		}
		this.calculatingTank = false;
	}

	private async load() {
		this.loading = true;

		try {
			// set formulas
			await this.formulasService.initalise();
			if (this.tank.formulaId) {
				this.formulaInputs = this.formulasService.getFormulaInputs(this.tank.formulaId) ?? [];
				if (this.tank.parameters) {
					const parameters: Record<string, any> = this.tank.parameters;
					this.formulaInputs.forEach((input: FormulaInput) => {
						input.value = parameters[input.name];
					});
				}
			}
			await this.calculateTankVolume();
			await this.setDistributors();
			await this.fetchFuelTypes();
		} catch (e) {
			console.log(e);
		} finally {
			this.loading = false;
		}
	}

	public async created() {
		await this.load();
	}

	private async setDistributors() {
		const api = new OrgsApi();
		const response = await api.orgGetPartnersByProductType('fuel');
		this.distributors = response.data.data;
		const dist = [];
		dist.push({ value: null, text: 'No Distributor' });
		this.distributors.forEach(row => {
			dist.push({ value: row.id, text: row.name });
		});
		this.distributors = dist.sort((a, b) => a.text.localeCompare(b.text));
	}

	private async fetchFuelTypes(): Promise<void> {
		try {
			const fuelTypesResponse = await this.axios.get<Array<{ type: string; label: string }>>(
				process.env.VUE_APP_API_URL + `/tanks/fuelTypes`,
			);
			this.fuelTypes = fuelTypesResponse.data.data;
		} catch (errorResponse) {
			const error = errorResponse as AxiosError;
		}
	}

	public async updateTank() {
		this.formulaInputs
			.filter((input: FormulaInput) => !!input.value)
			.forEach((input: FormulaInput) => (input.valid = true));
		const emptyFormulaInputs = this.formulaInputs.filter((input: FormulaInput) => !input.value);
		if (emptyFormulaInputs.length > 0) {
			this.submitStatus = 'ERROR';
			emptyFormulaInputs.forEach((input: FormulaInput) => (input.valid = false));
			return;
		}

		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}

		let data: Tank = {
			name: this.tank.name,
			fuelTankId: this.tank.fuelTankId ? this.tank.fuelTankId.toString() : null,
			fuelType: this.tank.fuelType,
			distributorId: this.tank.distributorId,
			fluctuation: this.tank.fluctuation,
			formulaId: this.tank.formulaId,
			nominalVolume: this.tank.nominalVolume,
			outletHeight: this.tank.outletHeight,
			totalHeight: this.tank.totalHeight,
			safeFillVolume: this.tank.safeFillVolume,
			parameters: {},
		};
		this.formulaInputs.forEach(i => ((data.parameters as Record<string, any>)[i.name] = i.value));
		try {
			await new TanksApi().provisionTank(this.tank.id, { data });
		} catch (e) {
			console.log(e);
			let error;
			if (e.response) {
				error = 'Error Provisioning Tank ' + e.response.data.message;
			} else if (e.request) {
				error = 'Error Provisioning Tank, network Error';
			} else {
				error = 'Error Provisioning Tank';
			}
			new Toast().makeToast(error, 'Error Provisioning Tank', 'danger', false);
			this.submitStatus = 'ERROR';
			return;
		}
		new Toast().makeToast('Successfully Provisioned Tank', 'Successful', 'success', false);
		this.cancel();
	}

	private get calculatedNominalDifferent(): boolean {
		return (
			Math.abs((this.tank?.nominalVolume ?? 0) - this.calculation.maxVolume) >
			this.calculation.maxVolume * 0.1
		);
	}
}
